import React, { useState, forwardRef } from "react";

import { StyledWrapper, StyledTextAreaWrapper } from "./inputForm.style";
import CommentUserInfo from "../commentUserInfo/commentUserInfo.component";
import useCurrentUser from "../../../hooks/useCurrentUser";

const MAX_INPUT_LENGTH = 400;

const InputForm = forwardRef(
  (
    {
      handlePostComment,
      parentId = null,
      intentLevel = 0,
      setShowReplyForm = undefined,
      setShowReplies = undefined,
      showForm = true,
    },
    ref,
  ) => {
    const [inputValue, setInputValue] = useState("");
    const isReply = parentId !== null;

    const currentUser = useCurrentUser();

    const handleSubmit = (e) => {
      e.preventDefault();
      handlePostComment(inputValue, parentId, commentPostCallback);
    };

    const commentPostCallback = () => {
      setInputValue("");
      if (setShowReplyForm) setShowReplyForm(false);
      if (setShowReplies) setShowReplies(true);
    };

    return (
      <StyledWrapper
        ref={ref}
        showform={showForm ? 1 : 0}
        style={{ maxHeight: showForm ? `${ref?.current?.scrollHeight}px` : 0 }}
        intentlevel={intentLevel}
      >
        <div>
          <CommentUserInfo data={currentUser} />
          <StyledTextAreaWrapper intentlevel={intentLevel}>
            <span>{isReply ? "Add a reply" : "Have a question?"}</span>
            <textarea
              maxLength={MAX_INPUT_LENGTH}
              placeholder="Start typing here..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <div>
              <span>{inputValue.length}</span> / {MAX_INPUT_LENGTH} Characters
            </div>
          </StyledTextAreaWrapper>
        </div>
        <div>
          <button onClick={handleSubmit}>Submit</button>
        </div>
      </StyledWrapper>
    );
  },
);
InputForm.displayName = "InputForm";

export default InputForm;
